<template>
    <button
        @click="$emit('click')"
        :class="['app-btn', { 'my-3 mt-4': !noMargin }, { disabled }]"
    >
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        noMargin: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.app-btn {
    font-size: 13px;
    font-weight: 500;
    color: white;
    padding: 10px 20px;
    border-radius: $radiusSm;
    min-width: 120px;
    background: $primaryColor;
    border: none;
    cursor: pointer;
    letter-spacing: 0.01em;
    transition: all $transitionFast;
    position: relative;
    overflow: hidden;

    &:hover {
        background: $primaryDark;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 94, 137, 0.3);
    }

    &:active {
        transform: translateY(0);
        box-shadow: none;
    }

    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }
}
</style>
